<section class="w3l-form-25">
  <div class="form-inner-cont">
      <div class="w3l-form-25">
          <h1>Treatment Rooms Master Data</h1>
          <p>Enter Treatment Rooms Master Data below to stay updated </p>
      </div>
</div>
</section>
<section class="w3l-hero-headers-11 p-sticky-md">
  <div class="top-header">
          <div class="d-grid grid-columns-top-3">
              <div class="accounts">
                  <ul>
                      <li></li>
                      <li></li>
                  </ul>
              </div>

  </div>

<div id="w3l-appointment">
<section class="appointment-section section-gap">

<div id="w3l-appointment">
<section class="appointment-section section-gap">
<div class="wrapper">
<div class="d-grid doctor-appointment">
    <div class="appointment-form">
        <form action="#" method="post">
            <div class="fields-grid">
              <div class="styled-input">
                <label>Room Number</label>
                <div class="appointment-form-field">
                    <span class="fa fa-search" style="cursor: grab;" aria-hidden="true" (click)="openDialog()"></span>
                    <input type="text" name="RoomID_1" id="RoomId_1" maxlength="3ch" placeholder="Room Code" [(ngModel)]="roomCode" (change)="retriveRooms()"  style="width: 30%;">

                </div>
              </div>
              <div class="styled-input">
                    <label>Room Name</label>
                    <div class="appointment-form-field">
                        <span class="fa fa-edit" aria-hidden="true"></span>
                        <input type="text" name="Roomname" maxlength="50ch"  [(ngModel)]="roomName"  placeholder="Room Name" required="">
                    </div>
              </div>

              <div class="styled-input">
                <label>Room Type</label>
                <div class="appointment-form-field">
                    <span class="fa fa-sitemap" aria-hidden="true"></span>
                    <select id="roomtype" required="" name="roomtype"  [(ngModel)]="roomType" [value]="roomType">
                        <option value="Type">Type*</option>
                        <option value ="Folllow up">Folllow up</option>
                        <option value="Consultation">Consultation</option>
                        <option value="Treatment">Treatment</option>
                        <option value="Follow up Visit">Follow up Visit</option>
                        <option value="Others">Others</option>
                    </select>
                </div>
            </div>


                <div class="styled-input">
                    <label>Notes</label>
                    <div class="appointment-form-field">
                        <span class="fa fa-university" aria-hidden="true"></span>
                        <input type="text" name="notes"  [(ngModel)]="roomNotes" placeholder="Notes" required="" >
                    </div>
                </div>
            </div>
        </form>
    </div>

    <div class="registerimg">
        <img src="assets/images/treatment.jpg" alt="" />
    </div>
</div>
</div>
</section>
<section>
  <div class="appointment-form" style="text-align: center;">
    <button type="button" class="theme-button btn" (click)="submitRooms()" name="submit">Submit</button>
    <button type="button" class="theme-button btn" name="Delete" (click)="mesgDelete()">Delete</button>
    <button type="button" class="theme-button btn" (click)="NewData()" name="New">New</button>
    <a href="Home">
    <button type="button" class="theme-button btn"  name="Back">Home</button>
    </a>
  </div>




